import { useContext } from 'react';

import TeamContext, { View } from '@atom/components/teamPortal/TeamContext';
import { useNavigation } from '@atom/hooks/useNavigation';
import { Icon, IconButton } from '@atom/mui';
import { FileDownloadIcon, ListIcon, MapIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';

import classes from './teamPortal.module.css';

const TeamHeader = () => {
  const [{ view }] = useNavigation();
  const { isMapView, setIsMapView, csvDownloadEndpoint } =
    useContext(TeamContext);

  const displayDownloadLink =
    hasRolePermissions(ROLE_SETS.INSPECTOR) &&
    !isMapView &&
    view !== View.DIRECTORY;

  return (
    <div className={classes.headerContainer}>
      <div className={classes.nameContainer}>Team</div>
      <div>
        {displayDownloadLink && (
          <IconButton
            tooltip="Download CSV"
            href={csvDownloadEndpoint}
            download
          >
            <Icon color={colors.neutral.white} icon={FileDownloadIcon} />
          </IconButton>
        )}
        <IconButton
          tooltip={`${isMapView ? 'List' : 'Map'} View`}
          onClick={() => setIsMapView(!isMapView)}
        >
          <Icon
            color={colors.neutral.white}
            icon={isMapView ? ListIcon : MapIcon}
          />
        </IconButton>
      </div>
    </div>
  );
};

export default TeamHeader;
